import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGeneratorHeroCard from '../components/ResponseBlockGeneratorHeroCard';
import { gAPI_Response_RelatedTopics } from '../../../../../constants/APIs';

export default class RelatedTopics extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGeneratorHeroCard getUrl={gAPI_Response_RelatedTopics} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
